import { render } from "./FileSystem.vue?vue&type=template&id=9c03dd0e&scoped=true&ts=true"
import script from "./FileSystem.vue?vue&type=script&lang=ts"
export * from "./FileSystem.vue?vue&type=script&lang=ts"

import "./FileSystem.vue?vue&type=style&index=0&id=9c03dd0e&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c03dd0e"]])

export default __exports__